import { createMyPluginFactory } from '../plateFunctions';
import { ELEMENT_EMBED } from '../plateTypes';
import { getValidVideoProvider } from './createVideoEmbedPlugin';

const EDITOR_VIEWPORT_WIDTH = 640;

export const createEmbedPlugin = createMyPluginFactory({
  key: ELEMENT_EMBED,
  isElement: true,
  isVoid: true,
  deserializeHtml: {
    rules: [
      {
        validNodeName: 'IFRAME',
      },
    ],
    getNode: (el: HTMLElement) => {
      const url = el.getAttribute('src');

      // Video plugin will handle video embeds
      const provider = getValidVideoProvider(url);
      if (provider) return;

      let height: number;
      const parentPB =
        el.parentElement?.style.getPropertyValue('padding-bottom');
      const heightAttr = el.getAttribute('height');
      // Use parent padding-bottom if it's a percentage
      if (parentPB?.endsWith('%')) {
        height = (parseFloat(parentPB) / 100) * EDITOR_VIEWPORT_WIDTH;
      } else if (heightAttr && !heightAttr.endsWith('%')) {
        height = parseInt(heightAttr, 10);
      } else {
        height = 480;
      }

      return {
        type: ELEMENT_EMBED,
        src: el.getAttribute('src'),
        title: el.getAttribute('title') || undefined,
        height,
        children: [{ text: '' }],
      };
    },
  },
});
